<div class="card card-custom h-100 WidgetSupervisor-filter">
    <div class="card-header align-items-center border-0">
        <h3 class="card-title align-items-start flex-column">
            <span class="font-weight-bolder text-dark">
                {{l("WidgetWeeklyPayrollReport")}}
            </span>
        </h3>
        <div class="card-toolbar">
            <button mat-icon-button [matMenuTriggerFor]="menu" class="btn">
                <mat-icon>download</mat-icon>
            </button>

            <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="exportData('pdf')" disabled>pdf</button>
                <button mat-menu-item (click)="exportData('csv')" disabled>csv</button>
                <button mat-menu-item (click)="exportData('xlsx')">xlsx</button>
            </mat-menu>
            <div class="mr-3 mb-3">
                <button class="btn btn-default" [ngClass]="{ 'btn-primary': personnelFilterIsActive, 'btn-inverted': !personnelFilterIsActive }" (click)="personnelSelector.open()">
                    {{ l("PersonnelFilter") }}
                </button>

                <div class="filter-button">
                    <mat-form-field>
                        <mat-select [formControl]="personnelFormCtrl" [multiple]="true" #personnelSelector>
                            <mat-option>
                                <ngx-mat-select-search noEntriesFoundLabel="No results found"
                                                       placeholderLabel="Find a personnel..." [formControl]="personnelFilterFormCtrl"
                                                       (input)="filterPersonnels()">
                                </ngx-mat-select-search>
                            </mat-option>
                            <mat-option *ngFor="let personnel of filteredPersonnel | async" [value]="personnel"
                                        (click)="refresh()" #option>
                                {{ personnel.firstName }} {{ personnel.lastName }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="mr-3 mb-3">
                <button class="btn btn-default" [ngClass]="{ 'btn-primary': nameFilterIsActive, 'btn-inverted': !nameFilterIsActive }" (click)="nameSelector.open()">
                    {{ l("Supervisor") }}
                </button>

                <div class="filter-button">
                    <mat-form-field>
                        <mat-select [formControl]="nameFormCtrl" [multiple]="true" #nameSelector>
                            <mat-option>
                                <ngx-mat-select-search noEntriesFoundLabel="No results found"
                                                       placeholderLabel="Find a supervisor..." [formControl]="nameFilterFormCtrl"
                                                       (input)="filterNames()">
                                </ngx-mat-select-search>
                            </mat-option>
                            <mat-option *ngFor="let name of  filteredName | async" [value]="name" (click)="refresh()"
                                        #option>
                                {{l(name.staffUser.userName)}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="mr-3 mb-3">
                <button class="btn btn-default" [ngClass]="{ 'btn-primary': companyFilterIsActive, 'btn-inverted': !companyFilterIsActive }" (click)="companySelector.open()">
                    {{ l("Company") }}
                </button>
                <div class="filter-button">
                    <mat-form-field>
                        <mat-select [formControl]="companyFormCtrl" [multiple]="true" #companySelector>
                            <mat-option>
                                <ngx-mat-select-search noEntriesFoundLabel="No results found"
                                                       placeholderLabel="Find a company..." [formControl]="companyFilterFormCtrl"
                                                       (input)="filterCompany()">
                                </ngx-mat-select-search>
                            </mat-option>
                            <mat-option *ngFor="let company of filteredCompany | async" [value]="company"
                                        (click)="refresh()" #option>

                                {{l(company.companyName)}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
    <div class="report-sub-header-section">
        <div class="report-sub-header-week">
            <p>{{ l("SelectedWeek") }}: <span>{{startDate | date: "dd/MM/yy"}} - {{endDate | date: "dd/MM/yy"}}</span></p>
            <div class="report-filter" *ngIf="filterNameShow"><a (click)="clear()"><mat-icon>close</mat-icon></a><span>{{ filterNameShow }}</span></div>
        </div>
        <div class="report-sub-header-date">
            <div class="report-sub-header">
                <div class="report-sub-header-btn">
                    <button (click)="GetThisWeek()" mat-button class="report-sub-header-button">
                        <mat-icon>today</mat-icon>
                        <span>{{ l("Today") }}</span>
                    </button>
                </div>
                <div class="report-sub-header-navigate-before">
                    <mat-icon (click)="GetPrevWeek()">navigate_before</mat-icon>
                </div>
                <div class="report-sub-header-navigate-after">
                    <mat-icon (click)="GetNextWeek()">navigate_next</mat-icon>
                </div>
                <div class="report-sub-header-datepicker">
                    <mat-form-field>
                        <mat-label>{{ l("ChooseADate") }}</mat-label>
                        <input matInput [matDatepicker]="datepicker" (dateInput)="onDateSelected($event)">
                        <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                        <mat-datepicker #datepicker></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
    <div class="card-bodyForStickyTable table-container">
        <p-table [value]="allocations" [paginator]="false" [lazy]="true" role="grid"
                 class="detailContentTable">
            <ng-template pTemplate="header">
                <tr>
                    <th>{{ l("AllocationDate") }}</th>
                    <th>{{ l("ReportOperativeName") }}</th>
                    <th>{{ l("ReportGaneID") }}</th>
                    <th>{{ l("Trade") }}</th>
                    <th>{{ l("ReportLabourCompany") }}</th>
                    <th>{{ l("Supervisor") }}</th>
                    <th>{{ l("Foreman") }}</th>
                    <th>{{ l("ReportPlantCompany") }}</th>
                    <th>{{ l("ReportSerialNumber") }}</th>
                    <th>{{ l("PlantType") }}</th>
                    <th>{{ l("ReportClockInTime") }}</th>
                    <th>{{ l("ReportClockOutTime") }}</th>
                    <th>{{ l("ReportNightShift") }}</th>
                    <th>{{ l("ReportAbsenceType") }}</th>
                    <th>{{ l("ReportHoursWorked") }}</th>
                    <th>{{ l("ReportWorksLocation") }}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-record>
                <tr class="height40">
                    <td>{{record.allocationDate | date: "dd/MM/yy"}}</td>
                    <td>{{record.operativeName ? record.operativeName : "-"}}</td>
                    <td>{{record.ganeID ? record.ganeID : "-"}}</td>
                    <td>{{record.trade ? record.trade : "-"}}</td>
                    <td>{{record.labourHireCompany ? record.labourHireCompany : "-"}}</td>
                    <td>{{record.supervisor ? record.supervisor : "-"}}</td>
                    <td>{{record.foreman ? record.foreman : "-"}}</td>
                    <td>{{record.plantHireCompany ? record.plantHireCompany : "-"}}</td>
                    <td>{{record.plantSerialNumber ? record.plantSerialNumber : "-"}}</td>
                    <td>{{record.plantType ? record.plantType : "-"}}</td>
                    <td>{{record.clockInTime | date: "HH:mm"}}</td>
                    <td>{{record.clockOutTime | date: "HH:mm"}}</td>
                    <td>{{record.nightShift ? record.nightShift : "-"}}</td>
                    <td>{{record.absenceType ? record.absenceType : "-"}}</td>
                    <td>{{record.hoursWorks ? record.hoursWorks : "-"}}</td>
                    <td>{{record.worksLocation ? record.worksLocation : "-"}}</td>
                </tr>
            </ng-template>
        </p-table>
        <div class="total-records-count">
            {{'TotalRecordsCount' | localize:primengTableHelper.totalRecordsCount}}
        </div>
    </div>
</div>
